import { Skeleton } from "primereact/skeleton";
import { formatShortDate } from "sj-ui-toolkit/src/utils";
import type { PassedBelt } from "sj-ui-toolkit/src/api/user";

export function CertificateInfoColumn({
  rowData,
  loading,
}: {
  rowData: PassedBelt;
  loading: boolean;
}) {
  if (loading) return <Skeleton />;

  return (
    <div className="flex flex-col" data-testid={`certificate-info-${rowData.id}`}>
      <span className="body-md">
        {rowData.levelName}: {rowData.name}
      </span>
      <span className="body-sm text-muted-aaa">Earned: {formatShortDate(rowData.completedAt)}</span>
    </div>
  );
}
